import type { WizardTileConfig } from '../../types/tileConfig';

const TILE_CONFIGS: WizardTileConfig[] = [
  {
    label: 'offerWizard.stepFacilityType.wind',
    value: 'wind',
    iconComponent: 'WindradIcon',
    urlValue: 'Wind',
  },
  {
    label: 'offerWizard.stepFacilityType.wasser',
    value: 'wasser',
    iconComponent: 'WasserkwIcon',
    urlValue: 'Wasser',
  },
  {
    label: 'offerWizard.stepFacilityType.photovoltaik',
    value: 'photovoltaik',
    iconComponent: 'PhotovoltaikIcon',
    urlValue: 'PV',
  },
  {
    label: 'offerWizard.stepFacilityType.biomasse',
    value: 'biomasse',
    iconComponent: 'BiomasseIcon',
    urlValue: 'Biomasse',
  },
];

export default TILE_CONFIGS;
